"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundingSpecV1 = exports.formatQuantity = exports.formatPercentage = exports.formatMinutes = exports.aggregate = exports.computeLine = exports.CalculationPolicyV1 = void 0;
const aggregation_1 = require("./aggregation");
const line_formula_1 = require("./line-formula");
const rounding_1 = require("./rounding");
exports.CalculationPolicyV1 = {
    versionLabel: "v1",
    computeLine: line_formula_1.computeLine,
    aggregate: aggregation_1.aggregate,
    rounding: {
        formatQuantity: rounding_1.formatQuantity,
        formatPercentage: rounding_1.formatPercentage,
        formatMinutes: rounding_1.formatMinutes,
    },
};
var line_formula_2 = require("./line-formula");
Object.defineProperty(exports, "computeLine", { enumerable: true, get: function () { return line_formula_2.computeLine; } });
var aggregation_2 = require("./aggregation");
Object.defineProperty(exports, "aggregate", { enumerable: true, get: function () { return aggregation_2.aggregate; } });
var rounding_2 = require("./rounding");
Object.defineProperty(exports, "formatMinutes", { enumerable: true, get: function () { return rounding_2.formatMinutes; } });
Object.defineProperty(exports, "formatPercentage", { enumerable: true, get: function () { return rounding_2.formatPercentage; } });
Object.defineProperty(exports, "formatQuantity", { enumerable: true, get: function () { return rounding_2.formatQuantity; } });
Object.defineProperty(exports, "roundingSpecV1", { enumerable: true, get: function () { return rounding_2.roundingSpecV1; } });
//# sourceMappingURL=index.js.map